module.exports = __webpack_public_path__ + "static/media/view1.0a07b2f3.jpg";